import { idcfg } from "../components/idconfig"
import { useState, useEffect } from 'react'

export const generateDocId = (docType) => {
  const now = new Date();
  const year = now.getFullYear() % 100; // Last two digits of the year
  const month = now.getMonth(); // 0-11
  const day = now.getDate(); // 1-31
  const hour = now.getHours(); // 0-23
  const minute = now.getMinutes(); // 0-59
  const second = now.getSeconds(); // 0-59
  const millisecond = now.getMilliseconds(); // 0-999

  let typeChr;

  switch (docType) {
    case 'message':
      typeChr = idcfg[0].type[0]
      break
    case 'quotation':
      typeChr = idcfg[0].type[1] // MQVDRPCS
      break
    case 'invoice':
      typeChr = idcfg[0].type[2]
      break
    case 'delivery':
      typeChr = idcfg[0].type[3]
      break
    case 'receipt':
      typeChr = idcfg[0].type[4]
      break
    case 'purchase':
      typeChr = idcfg[0].type[5]
      break
    case 'credit':
      typeChr = idcfg[0].type[6]
      break
    case 'statement':
      typeChr = idcfg[0].type[7]
      break
    case 'organization':
      typeChr = idcfg[0].type[8]
    break
    case 'company':
      typeChr = idcfg[0].type[8]
      break
    case 'user':
      typeChr = idcfg[0].type[9]
      break
    case 'expense':
      typeChr = idcfg[0].type[10]
      break
    case 'product':
      typeChr = idcfg[0].type[11]
      break
    case 'contact':
      typeChr = idcfg[0].type[12]
      break
    case 'address':
      typeChr = idcfg[0].type[14]
      break
    case 'goodreceive':
      typeChr = idcfg[0].type[15]
      break
    case 'employee':
      typeChr = idcfg[0].type[16]
      break
    case 'annoucement':
      typeChr = idcfg[0].type[17]
      break
    case 'project':
      typeChr = idcfg[0].type[18]
      break;
    case 'task':
      typeChr = idcfg[0].type[19]
      break
    case 'subscription':
      typeChr = idcfg[0].type[20]
      break
    default:
      typeChr = idcfg[0].type[13]
  }

  const id = `${typeChr}${idcfg[0].year[year]}` + 
                  `${idcfg[0].month[month]}` +
                  `${idcfg[0].day[day]}` +
                  `${idcfg[0].hour[hour]}` +
                  `${idcfg[0].minute[minute]}` +
                  `${idcfg[0].seconds[second]}` +
                  `-${millisecond.toString().padStart(3,'0')}` + 
                  `${(year + month + day + hour + minute + second + millisecond)%idcfg[0].checksum}`

  return `${id}`
};

const useCreateId = (docType) => {
  const [docId, setDocId] = useState('')

  useEffect(() => {
    setDocId(generateDocId(docType))
  }, [docType])

  return { docId }
}

export default useCreateId
